<template>
  <v-dialog v-model="dialog" max-width="1500">
    <v-card :loading="loading">
      <v-card-title>
        Candidate details
      </v-card-title>

      <v-tabs
        @change="onCurrentTabChanged"
        background-color="light-blue darken-4"
        center-active
        dark
        v-model="currentTab"
        show-arrows
      >
        <v-tab v-for="(tab, key) in tabs" :key="`tab-${key}`">{{ tab }}</v-tab>
        <template v-slot:next>
          <v-btn text @click="next()"><v-icon>mdi-chevron-right</v-icon></v-btn>
        </template>
      </v-tabs>

      <v-card-text v-if="!!resource">
        <languages :resource="resource" v-if="currentTab == LANGAUGE_TAB" @editResource="editResource" />
        
        <Recognation :resource="resource" v-if="currentTab == RECOGNATION_TAB" @editResource="editResource" />

        <evaluations
          @openDialog="
            (name) => {
              newResource = {};
              openDialog(name);
            }
          "
          @editResource="editResource"
          @deleteResource="triggerDelete"
          @loadResource="getResource"
          @pageByNumber="loadByPage"
          :evaluations="evaluations"
          v-if="currentTab == EVALUDATIONS_TAB"
        />

        <interviews
          @openDialog="
            (name) => {
              newResource = {};
              openDialog(name);
            }
          "
          @editResource="editResource"
          @deleteResource="triggerDelete"
          @loadResource="getResource"
          @pageByNumber="loadByPage"
          @copyS="clipboardSuccessHandler"
          :interviews="interviews"
          v-if="currentTab == INTERVIEWS_TAB"
        />

        <visa @copyS="clipboardSuccessHandler" :resource="resource" :updatedResource="updatedResource" v-if="currentTab == VISA_TAB" @editResource="editResource" />

        <submissionRequests
          v-if="currentTab == SUBMISSION_REQUESTS_TAB"
          :submission_requests="submission_requests"
          :candidate="resource"
          @loadResource="getResource"
          @pageByNumber="loadByPage"
        />

        <timeline
          @openDialog="
            (name) => {
              newResource = {};
              openDialog(name);
            }
          "
          @editResource="editResource"
          @deleteResource="triggerDelete"
          @loadResource="getResource"
          @pageByNumber="loadByPage"
          :updates="updates"
          v-if="currentTab == UPDATES_TAB"
        />

        <documents
          @openDialog="
            (name) => {
              newResource = {};
              openDialog(name);
            }
          "
          @editResource="editResource"
          @deleteResource="triggerDelete"
          @loadResource="getResource"
          @pageByNumber="loadByPage"
          @copyS="clipboardSuccessHandler"
          :documents="documents"
          v-if="currentTab == DOCUMENTS_TAB"
        />

        <calls
          @openDialog="
            (name) => {
              newResource = {};
              openDialog(name);
            }
          "
          @editResource="editResource"
          @deleteResource="triggerDelete"
          @loadResource="getResource"
          @pageByNumber="loadByPage"
          :calls="calls"
          v-if="currentTab == CALLS_TAB"
        />

        <notes
          @openDialog="
            (name) => {
              newResource = {};
              openDialog(name);
            }
          "
          @editResource="editResource"
          @deleteResource="triggerDelete"
          @loadResource="getResource"
          @pageByNumber="loadByPage"
          :notes="notes"
          v-if="currentTab == NOTES_TAB"
        />

        <transactions
          @openDialog="
            (name) => {
              newResource = {};
              openDialog(name);
            }
          "
          @editResource="editResource"
          @deleteResource="triggerDelete"
          @loadResource="getResource"
          @pageByNumber="loadByPage"
          :transactions="transactions"
          v-if="currentTab == TRANSACTIONS_TAB"
        />

        <appointments
          v-if="appointments.data && currentTab == APPOINTMENTS_TAB"
          :appointments="appointments"
          @deleteResource="(r) => (deleteResource(r, 'appointment'))"
          @loadResource="getResource"
        />

        <candidateQrCode
          v-if="qrcode && currentTab == QRCODE_TAB"
          :qrcode="qrcode"
        />

        <multiDialog
          :loading="loading"
          :deleting="deleting"
          :dialog="newEditDialog"
          :newResource="newResource"
          :resourceKeys="resourceKeys"
          :resourceSettings="resourceSettings"
          @closeDialog="
            () => {
              newEditDialog = false;
              deleting = false;
            }
          "
          @deleteResource="deleteResource"
          @updateResource="updateResource"
          @postResource="postResource"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.stop="dialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import evaluations from "@/components/candidate_dialog/evaluations.vue";
import interviews from "@/components/candidate_dialog/interviews.vue";
import timeline from "@/components/candidate_dialog/timeline.vue";
import calls from "@/components/candidate_dialog/calls.vue";
import documents from "@/components/candidate_dialog/documents.vue";
import submissionRequests from "@/components/candidate_dialog/submissionRequests.vue";
import notes from "@/components/candidate_dialog/notes.vue";
import transactions from "@/components/candidate_dialog/transactions.vue";
import appointments from "@/components/candidate_dialog/appointments.vue";
import visa from "./candidate_dialog/visa.vue";
import languages from "./candidate_dialog/languages.vue";
import newEditCandidateDetailsDialog from "./newEditCandidateDetailsDialog.vue";
import candidateQrCode from "./candidateQrCode.vue";
import multiDialog from "./multiDialog.vue";
import Recognation from "./candidate_dialog/recognation.vue";

export default {
  components: {
    candidateQrCode,
    evaluations,
    interviews,
    timeline,
    submissionRequests,
    documents,
    calls,
    notes,
    transactions,
    appointments,
    visa,
    languages,
    newEditCandidateDetailsDialog,
    multiDialog,
    Recognation
},
  props: {
    resource: {
      type: Object,
      default: null,
    },
  },
  data() {
    const LANGAUGE_TAB = 0;
    const EVALUDATIONS_TAB = 1;
    const INTERVIEWS_TAB = 2;
    const VISA_TAB = 3;
    const SUBMISSION_REQUESTS_TAB = 4;
    const UPDATES_TAB = 5;
    const DOCUMENTS_TAB = 6;
    const CALLS_TAB = 7;
    const NOTES_TAB = 8;
    const TRANSACTIONS_TAB = 9;
    const APPOINTMENTS_TAB = 10;
    const QRCODE_TAB = 11;
    const RECOGNATION_TAB = 12;

    return {
      updatedResource: null,
      newEditDialog: false,
      currentTab: LANGAUGE_TAB,
      loading: false,
      tabs: [
        "Language",
        "Evaluations",
        "Interviews",
        "Visa",
        "Submission requests",
        "Timeline",
        "Documents",
        "Calls",
        "Notes",
        "Transactions",
        "Appointments",
        "Qr code",
        "Recognation",
      ],
      updates: [],
      evaluations: [],
      interviews: [],
      calls: [],
      documents: [],
      notes: [],
      appointments: [],
      submission_requests: [],
      transactions: [],
      visa_details_keys: [],
      LANGAUGE_TAB,
      UPDATES_TAB,
      EVALUDATIONS_TAB,
      INTERVIEWS_TAB,
      CALLS_TAB,
      DOCUMENTS_TAB,
      NOTES_TAB,
      APPOINTMENTS_TAB,
      SUBMISSION_REQUESTS_TAB,
      TRANSACTIONS_TAB,
      VISA_TAB,
      QRCODE_TAB,
      RECOGNATION_TAB,

      qrcode: null,

      // Multi dialog
      resourceSettings: {
        resourceName: null,
        search: true,
        create: true,
        pagination: true,
      },

      deleting: false,

      newResource: {},
    };
  },
  methods: {
    getQrCode() {
      return new Promise(async (res, rej) => {
        this.qrcode = await this.$store.dispatch('getResource', {resource: `/candidates/${this.resource.id}/qr_code`})
        res(true)
      })
    },
    clipboardSuccessHandler() {
      this.$emit('copyS')
    },
    triggerDelete(name, resource) {
      this.newResource = { ...resource };

      this.deleting = true;
      this.openDialog(name);
    },
    splitDate(datetime) {
      return [
        datetime.split(" ")[0],
        datetime.split(" ")[1],
      ]
    },
    editResource(name, resource) {
      if (resource) {
        this.newResource = { ...resource };
      } else {
        this.newResource = {};
      }

      switch (name) {
        case "visa":
          this.newResource = resource
          
          let date_time = ["", ""]
          
          if (resource.visa_appointment)
            date_time = resource.visa_appointment.split(" ")

          this.newResource.visa_appointment_date = date_time[0]
          this.newResource.visa_appointment_time = date_time[1]
          break;
        case "languages":
          this.newResource = this.resource
          break;
        case "recognation":
          this.newResource = this.resource
          break;
        case "evaluation":
          const [evadate, evatime] = this.splitDate(this.newResource.appointment.appointment);
          this.newResource.appointment = evadate;
          this.newResource.appointment_time = evatime;
          break;
        case "interview":
          const [date, time]= this.splitDate(this.newResource.appointment.appointment);
          this.newResource.appointment = date;
          this.newResource.appointment_time = time;
          break;
        case "document":
          this.newResource.type_id = this.newResource.type;
          break;
        default:
          break;
      }

      this.openDialog(name);
    },
    openDialog(resourceName) {
      this.resourceSettings = {
        resourceName,
        search: true,
        create: true,
        pagination: true,
      };

      this.newResource.candidate_id = this.resource.id;

      this.newEditDialog = true;
    },
    async postResource(resource) {
      await this.postNewResource(this.resourceName + "s", this.resourceName, resource);
    },
    async updateResource(resource) {
      if (this.resourceName === "languages" || this.resourceName === "visa" || this.resourceName === 'recognation') {
        
        if (this.resourceName === "visa") {
          resource.visa_appointment = `${resource.visa_appointment_date} ${resource.visa_appointment_time}`
          delete resource.id
          delete resource.candidate_id
        }
        else {
          resource = this.resource
        }

        this.loading = true
        const response = await this.$store.dispatch('putResource', { resource: this.$route.path + `/${this.resource.id}`, value: resource })

        if (this.resourceName === "visa") {
          this.updatedResource = response.candidate
        }

        this.loading = false

        // Reset the mutli dialog
        this.newEditDialog = false;
        this.newResource = {};

        this.resourceSettings = {
          resourceName: null,
          search: true,
          create: true,
          pagination: true,
        };
        return
      }

      await this.putResource(this.resourceName + "s", this.resourceName, resource);
    },
    async deleteResource(resource, resourceName = null) {
      if (resourceName) {
        await this.submitDeleteResource(resourceName + "s", resourceName, resource);
        return
      }
      await this.submitDeleteResource(this.resourceName + "s", this.resourceName, resource);
    },
    async submitDeleteResource(model, update, resource) {
      this.loading = true;
      await this.$store.dispatch("deleteResource", {
        resource: `/can/delete_/${model}/${resource.id}`,
        value: resource,
      });
      await this.getResource(`${update}s`, update);
      this.loading = false;

      // Reset the mutli dialog
      this.newEditDialog = false;
      this.newResource = {};
      this.deleting = false;

      this.resourceSettings = {
        resourceName: null,
        search: true,
        create: true,
        pagination: true,
      };
    },
    async postNewResource(model, update, resource) {
      if (this.resourceName == 'interview' || this.resourceName == 'evaluation') {
        resource.appointment = `${resource.appointment} ${resource.appointment_time}`
        delete resource.appointment_time
      }
      
      this.loading = true;
      await this.$store.dispatch("postResource", { resource: "/can/create_/" + model, value: resource });
      await this.getResource(`${update}s`, update);
      this.loading = false;

      // Reset the mutli dialog
      this.newEditDialog = false;
      this.newResource = {};

      this.resourceSettings = {
        resourceName: null,
        search: true,
        create: true,
        pagination: true,
      };
    },
    async putResource(model, update, resource) {
      if (this.resourceName == 'interview' || this.resourceName == 'evaluation') {
        resource.appointment = `${resource.appointment} ${resource.appointment_time}`
        delete resource.appointment_time
      }

      this.loading = true;
      await this.$store.dispatch("putResource", { resource: `/can/update_/${model}/${resource.id}`, value: resource });
      await this.getResource(`${update}s`, update);
      this.loading = false;

      // Reset the mutli dialog
      this.newEditDialog = false;
      this.newResource = {};

      this.resourceSettings = {
        resourceName: null,
        search: true,
        create: true,
        pagination: true,
      };
    },
    firstLettersName(name) {
      const split_names = name.split(" ");
      if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase();
      return (split_names[0][0] + split_names[0][1]).toUpperCase();
    },
    async getResource(localData, model, filter = null, page = null) {
      this.loading = true;
      const id = this.resource.id;
      this[localData] = [];
      let data = []
      if (filter) {
        data = await this.$store.dispatch("getResource", { resource: `/can/get_/${model}/${id}?page=${page}` + filter });
      }
      else {
        data = await this.$store.dispatch("getResource", { resource: `/can/get_/${model}/${id}` });
      }
      this[localData] = data;
      this.loading = false;
    },
    async loadByPage(localData, model, page) {
      this.loading = true;
      const id = this.resource.id; // 160 for testing only
      const data = await this.$store.dispatch("getResource", { resource: `/can/get_/${model}/${id}?page=${page}` });
      this[localData] = data;
      this.loading = false;
    },
    async onCurrentTabChanged() {
      switch (this.currentTab) {
        case this.LANGAUGE_TAB:
          break;
        case this.UPDATES_TAB:
          await this.getResource("updates", "updates");
          break;
        case this.EVALUDATIONS_TAB:
          await this.getResource("evaluations", "evaluations");
          break;
        case this.INTERVIEWS_TAB:
          await this.getResource("interviews", "interviews");
          break;
        case this.CALLS_TAB:
          await this.getResource("calls", "calls");
          break;
        case this.DOCUMENTS_TAB:
          await this.getResource("documents", "documents");
          break;
        case this.NOTES_TAB:
          await this.getResource("notes", "notes");
          break;
        case this.APPOINTMENTS_TAB:
          await this.getResource("appointments", "appointments");
          break;
        case this.SUBMISSION_REQUESTS_TAB:
          await this.getResource("submission_requests", "submission_requests");
          break;
        case this.TRANSACTIONS_TAB:
          await this.getResource("transactions", "transactions");
          break;
        case this.VISA_TAB:
          break;
        case this.QRCODE_TAB:
          await this.getQrCode()
          break;
      }
    },
  },
  computed: {
    resourceName() {
      return this.resourceSettings.resourceName;
    },
    resourceKeys() {
      switch (this.resourceName) {
        case "languages":
          const language_details_keys = [
            "language_started",
            "a_1_started",
            "a_1_finished",
            "a_1_passed",
            "a_2_started",
            "a_2_finished",
            "a_2_passed",
            "a_2_certificate",
            "b_1_started",
            "b_1_finished",
            "b_1_passed",
            "b_1_certificate",
            "b_2_started",
            "b_2_finished",
            "b_2_passed",
            "b_2_certificate",
            "b_1_certificate_submited",
            "b_2_certificate_submited",
          ];
          
          return language_details_keys.map((item) => ({
            name: item, 
            label: item, 
            type: "switch",
            required: false, 
            readonly: false
          }))
        case "recognation":
          const recongation_keys = [
            "recognition_documents_ready",
            "recognition_documents_ready_date",
            "recognition_documents_submitted",
            "recognition_documents_submitted_date",
            "recognition_documents_reviewed",
            "recognition_documents_reviewed_date",
            "recognition_documents_sent_dhl",
            "recognition_documents_sent_dhl_date",
            "recognition_documents_recieved_dhl",
            "recognition_documents_recieved_dhl_date",
            "recognition_documents_submitted_to_authority",
            "recognition_documents_submitted_to_authority_date",
            "recognition_documents_result",
            "recognition_documents_result_date",
          ];
          
          return recongation_keys.map((item) => {
            if (item.includes('_date')) {
              return {
                name: item, 
                label: item, 
                type: "date",
                required: false,
                readonly: false
              }
            }
            
            return {
              name: item, 
              label: item, 
              type: "switch",
              required: false, 
              readonly: false
            }
          })
        case "visa":
          return [
            { name: "visas_access", label: "visas_access", type: "switch", required: false, readonly: false },
            { name: "visa_appointment_date", label: "visa_appointment_date", type: "date", required: false, readonly: false },
            { name: "visa_appointment_time", label: "visa_appointment_time", type: "time", required: false, readonly: false },
            { name: "visa_application_ready", label: "visa_application_ready", type: "switch", required: false, readonly: false },
            { name: "visa_application_submitted", label: "visa_application_submitted", type: "switch", required: false, readonly: false },
            { name: "visa_granted", label: "visa_granted", type: "switch", required: false, readonly: false },
            { name: "visa_granted_document", label: "visa_granted_document", type: "file", required: false, readonly: false },
            { name: "accelerated_procedure_documents_ready", label: "accelerated_procedure_documents_ready", type: "switch", required: false, readonly: false },
            { name: "accelerated_procedure_result", label: "accelerated_procedure_result", type: "switch", required: false, readonly: false },
            { name: "accelerated_procedure_result_document", label: "accelerated_procedure_result_document", type: "file", required: false, readonly: false },
            { name: "accelerated_procedure_submitted", label: "accelerated_procedure_submitted", type: "switch", required: false, readonly: false },
            { name: "ba_documents_ready", label: "ba_documents_ready", type: "switch", required: false, readonly: false },
            { name: "ba_result", label: "ba_result", type: "switch", required: false, readonly: false },
            { name: "ba_result_document", label: "ba_result_document", type: "file", required: false, readonly: false },
            { name: "airline_ticket_document", label: "airline_ticket_document", type: "file", required: false, readonly: false },
          ]
        case "evaluation":
          return [
            { name: "appointment", label: "appointment", type: "date", required: true, readonly: false },
            { name: "appointment_time", label: "appointment_time", type: "time", required: true, readonly: false },
            { name: "note", label: "note", type: "textarea", required: false, readonly: false },
            { name: "attended", label: "attended", type: "switch", required: false, readonly: false },
            { name: "result", label: "result", type: "text", required: false, readonly: false },
          ];
        case "interview":
          return [
            { name: "appointment", label: "appointment", type: "date", required: true, readonly: false },
            { name: "appointment_time", label: "appointment_time", type: "time", required: true, readonly: false },
            { name: "application", label: "application", type: "text", required: false, readonly: false },
            { name: "information", label: "information", type: "text", required: false, readonly: false },
            { name: "link", label: "link", type: "text", required: false, readonly: false },
            { name: "attended", label: "attended", type: "switch", required: false, readonly: false },
            { name: "accepted", label: "accepted", type: "switch", required: false, readonly: false },
            { name: "rejected", label: "rejected", type: "switch", required: false, readonly: false },
          ];
        case "update":
          return [
            { name: "update_field", label: "update_field", type: "text", required: true, readonly: false },
            { name: "update_value", label: "update_value", type: "text", required: true, readonly: false },
            { name: "note", label: "note", type: "textarea", required: false, readonly: false },
            { name: "approved", label: "approved", type: "switch", required: false, readonly: false },
            { name: "rejected", label: "rejected", type: "switch", required: false, readonly: false },
          ];
        case "document":
          return [
            { name: "type", label: "type", type: "select", data: this.documentTypes, required: true, readonly: false },
            { name: "url", label: "url", type: "file", required: true, readonly: false },
          ];
        case "call":
          return [
            { name: "note", label: "note", type: "textarea", required: false, readonly: false },
            { name: "answered", label: "answered", type: "switch", required: false, readonly: false },
          ];
        case "note":
          return [{ name: "note", label: "note", type: "textarea", required: true, readonly: false }];
        case "transaction":
          return [
            { name: "ammount", label: "ammount", type: "number", required: true, readonly: false },
            { name: "deadline", label: "deadline", type: "date", required: true, readonly: false },
            { name: "currency", label: "currency", type: "text", required: true, readonly: false },
            { name: "done", label: "done", type: "switch", required: false, readonly: false },
            { name: "approved", label: "approved", type: "switch", required: false, readonly: false },
            { name: "note", label: "note", type: "textarea", required: false, readonly: false },
          ];
        default:
          return [];
      }
    },
    documentTypes() {
      return [
        { slug: "other", ar: "مستندات اخرى" },
        { slug: "cv", ar: "سيرة ذاتية" },
        { slug: "portrait", ar: "صورة شخصية" },
        { slug: "certificate", ar: "شهادة" },
        { slug: "school_certificate", ar: "شهادة مدرسية" },
        { slug: "uni_certificate", ar: "شهادة جامعية" },
        { slug: "b_1_certificate", ar: "شهادة مستوى B1" },
        { slug: "b_2_certificate", ar: "شهادة مستوى B2" },
        { slug: "visa", ar: "نسخة عن التأشيرة" },
      ].map((item) => ({ text: item.ar, type_id: item.slug }));
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
    dialog: {
      get() {
        return !!this.resource;
      },
      set(value) {
        this.currentTab = 0;
        this.updates = [];
        this.$emit("close");
      },
    },
  },
  watch: {
    async resource(value) {},
  },
};
</script>
